module.exports = __webpack_public_path__ + "static/media/image009.d6cf5af1.jpg";